/** The 1v1 Entertainment mark, from their site. currentColor, so it takes
 *  the fill of whatever it sits on. */
export default function BrandMark({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 41 42" fill="none" aria-hidden="true">
      <path
        d="M34.9621 30.4076V6.49679H29.251V5.72898L40.9996 0V30.4076H34.9611H34.9621Z"
        fill="currentColor"
      />
      <path
        d="M24.3588 11.5918L20.5009 23.1098L16.6431 11.5918H11.1602L17.7595 30.408H23.2424L29.8417 11.5918H24.3588Z"
        fill="currentColor"
      />
      <path
        d="M6.03856 11.5918V35.5036H11.7497V36.2714L0 42.0004V11.5918H6.03856Z"
        fill="currentColor"
      />
    </svg>
  );
}
